import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Card, CardBody } from "reactstrap";
import 'react-table/react-table.css';
import { createUltimatePagination }  from "react-ultimate-pagination";
import { cloneDeep } from "lodash";
import { ContextMenuTrigger } from "react-contextmenu";
import ContextMenuContainer from "../../containers/pages/ContextMenuContainer";
import AppLocale from "../../config/lang";
import { replaceWords } from "../../helpers/Utils";

function Page(props) {
  return (
    <li className={"page-item " + (props.isActive ? 'active' : '')}>
      <button
        className="page-link"
        onClick={props.onClick}
        disabled={props.disabled}
      >{props.value}</button>
    </li>
  );
}

function Ellipsis(props) {
  return <li className="page-item"><button className="page-link" onClick={props.onClick} disabled={props.disabled}><i className="simple-icon-options"></i></button></li>
}

function PreviousPageLink(props) {
  return <li className={"page-item "+ (props.isActive ? 'disabled':'')}><button className="prev page-link" onClick={props.onClick} disabled={props.isActive}><i className="simple-icon-arrow-left"></i></button></li>
}

function NextPageLink(props) {
  return <li  className={"page-item "+ (props.isActive ? 'disabled':'')}><button className="next page-link" onClick={props.onClick} disabled={props.isActive}><i className="simple-icon-arrow-right"></i></button></li>
}

function Wrapper(props) {
  return <ul className="justify-content-center pagination pagination-sm mb-0 mt-3">{props.children}</ul>
}

var itemTypeToComponent = {
  'PAGE': Page,
  'ELLIPSIS': Ellipsis,
  'PREVIOUS_PAGE_LINK': PreviousPageLink,
  'NEXT_PAGE_LINK': NextPageLink,
};

var UltimatePagination = createUltimatePagination({
  itemTypeToComponent: itemTypeToComponent,
  WrapperComponent: Wrapper
});

class DataTable extends Component {
  constructor(props) {
    // console.log(props)
    super(props);
    this.state = {
      currentPage: 1,
      rowClickedData: null,
      expand: false
    };
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.currentPage > -1) this.setState({currentPage: nextProps.currentPage})
  }

  handleOnChangePagination(p) {
    if (p === -1) this.props.listenCurrentPage(p)
    else  {
      this.props.data.length = 0;
      this.setState(({ currentPage: p }), () => { this.props.listenCurrentPage(p) })
    }
  }

  columnsFormat = () => {
    const { locale } = this.props
    const L = AppLocale[locale].messages
    let cols = cloneDeep(this.props.columns)
    cols = cols.filter(c => !c.hidden)
    cols.map((e, i) => {
      if (e.isBool || e.type === "check") e.Header = <div className="w-100 text-center">{L[e.Header]?? e.Header}</div>
      else e.Header = L[e.Header]?? e.Header
      if (this.props.dataTableList) e.className = e.classList ? e.classList : (i > 3 && !e.isButton) ? 'd-none' : ''
      else e.className = e.classTable || ''
      return e
    })
    return cols
  }

  onContextMenuClick = (e, data, target) => {
    console.log("onContextMenuClick - action : ", data.action);
    alert(data.action + ': ' + this.state.rowClickedData.ID)
  };

  getTbodyProps = () => {
    let r = {}
    r.className = this.state.expand ? 'expand' : ''
    return r
  }

  getTheadTrProps = () => {
    let r = {}
    r.onClick = (e, handleOriginal) => {
      this.setState({
        expand: !this.state.expand
      });
      if (handleOriginal) {
        handleOriginal()
      }
    }
    r.style = {
      cursor: 'pointer'
    }
    return r
  }

  getTdProps = (state, rowInfo, column, instance) => {
    
    let r = {}
    /*
    r.onClick = (e, handleOriginal) => {
      this.setState({
        expand: !this.state.expand
      });
      if (handleOriginal) {
        handleOriginal()
      }
    }
    r.style = {
      cursor: 'pointer'
    }
    */
    if (this.props.enableContexMenu) {
      r.onContextMenu = () => {
        console.log("contextMenu", rowInfo);
        this.setState({rowClickedData: rowInfo.original});
      }
    }
    return r
  };

  maxHeight = () => {
    let r = null
    if (this.props.maxHeight) {
      r = {
        overflow: 'auto',
        maxHeight: this.props.maxHeight
      }
    }
    return r
  }

  render() {
    const { locale, rowCount, pageCount, progressBar, title, dataTableList, data, enableContexMenu, defaultPageSize, getTrProps, hidePagination, customMsg, msgNoRecords } = this.props
    const { currentPage  } = this.state
    const L = AppLocale[locale].messages
    return (
      <div>
        <div style={{height: '4px'}}>{progressBar && <div className="progress"><div className="indeterminate"></div></div>}</div>
        <Card className={"margin-bottom-60 " + (dataTableList ? "content-datalist " : "")} style={this.maxHeight()}>
          <CardBody>
            {title && <h5>{L[title]?? title}</h5>}
            {(this.props.currentPage === -1 || (!progressBar && data.length > 0)) &&
            <ContextMenuTrigger id="menu_id" disable={enableContexMenu ? false : true}>
              <ReactTable
                data={data}
                columns={this.columnsFormat()}
                pageSize={Math.min(data.length, defaultPageSize)}
                showPageJump={true}
                showPageSizeOptions={false}
                showPagination={false}
                sortable={false}
                resizable={false}
                className={"-highlight"}
                getTbodyProps={this.getTbodyProps}
                getTheadTrProps={this.getTheadTrProps}
                getTrProps={getTrProps ? getTrProps : (() => {})()}
                getTdProps={this.getTdProps}
              />
            </ContextMenuTrigger>
            }

            {/* show menu when right clicking on a table row */}
            {enableContexMenu && <ContextMenuContainer onContextMenuClick={this.onContextMenuClick} />}
            
            {(!hidePagination && data.length !== 0) &&
            <UltimatePagination
              totalPages={data.length < defaultPageSize ? currentPage : Math.max(currentPage, Math.ceil(9999 / defaultPageSize))}
              currentPage={currentPage}
              onChange={(p) => { this.handleOnChangePagination(p) }}
              hideFirstAndLastPageLinks={true}
            />}

            {!hidePagination && <div style={{ textAlign: 'center', fontSize: '12px' }} className="text-muted my-2">
              {/* customMsg || (data.length === 0 && !progressBar ? `${L["main.noRecords"]}` : `${L["main.showing"]} ${data.length}`) */}
              {customMsg || (
                data.length === 0 && !progressBar 
                ? msgNoRecords?? `${L["main.noRecords"]}`
                : rowCount === -1 && !progressBar
                ? <div>{`${data.length} ${L["main.records"]}`} <span className="btn-link pointer" onClick={() => { this.handleOnChangePagination(-1) }}>[Total]</span></div>
                : data.length >= 0 && progressBar
                ? L["main.loading"]
                : <div>{`${replaceWords(L["main.paginationDetail"], {"{0}":data.length, "{1}":rowCount, "{2}":currentPage, "{3}":pageCount })}`}</div>
              )}
            </div>
            }
          </CardBody>
        </Card>
      </div>
    );
  }
};

const mapStateToProps = ({ settings }) => {
  const { locale } = settings
  return { locale };
};

export default connect(mapStateToProps)(DataTable);